module.exports = __webpack_public_path__ + "img/swiper3.d69f2d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/swiper3.png
// module id = 387
// module chunks = 0